export enum VERTICAL_ID {
	MINECRAFT = 'minecraft',
	ROBLOX = 'roblox'
}

export class Vertical {
	readonly id: VERTICAL_ID;
	readonly variants?: VerticalVariant[];

	constructor(id: VERTICAL_ID, variants?: VerticalVariant[]) {
		this.id = id;
		this.variants = variants;
	}
}

export enum VERTICAL_VARIANT_ID {
	MINECRAFT_JAVA = 'minecraftJava',
	MINECRAFT_PE = 'minecraftPe'
}

export class VerticalVariant {
	readonly id: VERTICAL_VARIANT_ID;
	readonly verticalId: VERTICAL_ID;

	constructor(id: VERTICAL_VARIANT_ID, verticalId: VERTICAL_ID) {
		this.id = id;
		this.verticalId = verticalId;
	}
}

export const VERTICAL_VARIANTS = {
	[VERTICAL_VARIANT_ID.MINECRAFT_JAVA]: new VerticalVariant(
		VERTICAL_VARIANT_ID.MINECRAFT_JAVA,
		VERTICAL_ID.MINECRAFT
	),
	[VERTICAL_VARIANT_ID.MINECRAFT_PE]: new VerticalVariant(
		VERTICAL_VARIANT_ID.MINECRAFT_PE,
		VERTICAL_ID.MINECRAFT
	)
};

export const VERTICALS = {
	[VERTICAL_ID.MINECRAFT]: new Vertical(VERTICAL_ID.MINECRAFT, [
		VERTICAL_VARIANTS[VERTICAL_VARIANT_ID.MINECRAFT_JAVA],
		VERTICAL_VARIANTS[VERTICAL_VARIANT_ID.MINECRAFT_PE]
	]),
	[VERTICAL_ID.ROBLOX]: new Vertical(VERTICAL_ID.ROBLOX)
};
